import type { BadgeProps } from './Badge.types';

const baseClasses =
  'tw:inline-flex tw:items-center tw:rounded-[3px] tw:px-[5px] tw:py-[2px] tw:text-[0.8rem] tw:whitespace-nowrap tw:italic';

const variantClasses: Record<NonNullable<BadgeProps['variant']>, string> = {
  new: 'tw:bg-sq-warning-bg-color tw:dark:bg-sq-text-dark-warning-color tw:text-sq-text-dark-warning-color tw:dark:text-sq-warning-bg-color',
  preview:
    'tw:bg-sq-badge-preview-bg tw:dark:bg-sq-bg-default-preview-dark tw:text-sq-text-interactive tw:dark:text-sq-text-interactive-dark',
};

/**
 * Renders a compact inline badge for feature-state labels such as new or preview.
 */
export const Badge = ({ children, variant = 'new', testId, extraClassNames = '' }: BadgeProps) => {
  const appliedClasses = `${baseClasses} ${variantClasses[variant]} ${extraClassNames}`.trim();

  return (
    <span data-testid={testId} className={appliedClasses}>
      {children}
    </span>
  );
};

export default Badge;
